const actions = {
  SET_STATE: 'menu/SET_STATE',
  RELOAD: 'menu/RELOAD',
} as const

export type MenuActionTypes = typeof actions
export default actions
